import { useMatch, useNavigate } from "react-router";

import { Gear } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";
import useMainNavigationStore from "components/MainNavigation/stores/useMainNavigationStore";
import { selectNavigationShowsExpandedContent } from "components/MainNavigation/selectors/navigationState";
import useMainNavigationFadeTransition from "components/MainNavigation/hooks/useFadeTransition";

export const SIDEBAR_CUSTOMIZATION_PATH = "/personal-settings/sidebar-customization";

const MainNavigationSettingsButton = () => {
  const showsExpandedContent = useMainNavigationStore(selectNavigationShowsExpandedContent);

  const navigate = useNavigate();
  const { transitionClasses } = useMainNavigationFadeTransition(showsExpandedContent);

  const handleClick = () => navigate(SIDEBAR_CUSTOMIZATION_PATH);

  const match = useMatch(SIDEBAR_CUSTOMIZATION_PATH);

  return (
    <ButtonIcon
      icon={Gear}
      variant="ghost"
      size="small"
      onPress={handleClick}
      className={transitionClasses}
      active={!!match}
    >
      Sidebar customization
    </ButtonIcon>
  );
};

export default MainNavigationSettingsButton;
